{
  "countryCode": "Country code",
  "choosePlaceholder": "Choose the country",
  "countrySearch": "Search for a country by name or code",
  "noCountry": "No matching country",
  "helper": "Enter a mobile number",
  "errors": {
    "PHONE_REQUIRED": "The phone number is required",
    "PHONE_INVALID": "The phone number is not valid",
    "PHONE_NOT_MOBILE": "Landline numbers are not allowed. Enter a mobile number",
    "PHONE_COUNTRY_NOT_ALLOWED": "Numbers from this country are not accepted"
  },
  "verification": {
    "title": "Phone verification",
    "sending": "Sending the code...",
    "sent": "A verification code was sent by WhatsApp to {{phone}}",
    "validity": "The code is valid for {{minutes}} minutes",
    "code": "Verification code",
    "codeHelper": "Enter the code the customer received",
    "verify": "Verify",
    "verifying": "Verifying...",
    "resend": "Resend code",
    "resendIn": "Resend in {{seconds}} seconds",
    "changeNumber": "Change the number",
    "cancel": "Cancel",
    "verified": "The phone number has been verified",
    "wrongCode": "The code is incorrect. {{count}} attempts left",
    "expired": "The code has expired. Request a new code",
    "attemptsExceeded": "Too many wrong attempts. Request a new code",
    "sendLimit": "Too many codes were sent to this number. Try again in {{minutes}} minutes",
    "sendFailed": "The verification code could not be sent by WhatsApp. Nothing was saved. Try again, or an administrator can turn verification off in the settings",
    "notOnWhatsapp": "The message could not be delivered: the number is not on WhatsApp or does not accept messages",
    "unavailable": "The number could not be verified with the Customers system. Nothing was saved. Try again",
    "verifiedBadge": "Verified number",
    "unverifiedBadge": "Unverified number"
  }
}
